import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import Checkbox from '@mui/material/Checkbox';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import BellOutlinedIcon from 'components/icons/BellOutlinedIcon';
import toast from 'react-hot-toast';
import notificationServices from 'services/notificationServices';
import { useAppSelector } from 'app/hooks';
import { checkEnableParseJSON } from 'components/helper/helper';

interface Props { }

const SettingsNotification = (props: Props) => {
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [data, setData] = React.useState<any>();
  const userId = personalStore?.student_id;

  const getData = () => {
    if (userId) {
      notificationServices.getNotification(userId).then((res: any) => {
        setData(res);
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    getData();
  }, [userId]);

  const getEmailNotificationStatus = (
    userType: string,
    notificationType?: string,
    source?: string
  ) => {
    return (
      checkEnableParseJSON(data?.email_notification_array, [
        {
          noti_type: 'email',
          is_enabled: false,
        },
        {
          noti_type: 'sms',
          is_enabled: false,
        },
        {
          noti_type: 'email',
          is_enabled: false,
          type: "receive"
        },
        {
          noti_type: 'sms',
          is_enabled: false,
          type: "receive"
        },
      ])?.find((item: any) =>
        item.noti_type === userType &&
        (notificationType ? item.type === notificationType : !item.type) &&
        (source ? item.source === source : !item.source)
      )?.is_enabled || false
    );
  };

  const updateEmailNotificationStatus = (
    userType: string,
    isEnabled: boolean,
    notificationType?: string,
    source?: string
  ) => {
    const toastId = toast.loading('Saving...');

    // Default array with all notification types
    const defaultArray = [
      {
        noti_type: 'email',
        is_enabled: false,
      },
      {
        noti_type: 'sms',
        is_enabled: false,
      },
      {
        noti_type: 'email',
        is_enabled: false,
        type: "receive",
        source: "in-app"
      },
      {
        noti_type: 'sms',
        is_enabled: false,
        type: "receive",
        source: "in-app"
      },
      {
        noti_type: 'email',
        is_enabled: false,
        type: "receive",
        source: "gradmap"
      },
      {
        noti_type: 'sms',
        is_enabled: false,
        type: "receive",
        source: "gradmap"
      },
    ];

    let emailArray = data?.email_notification_array
      ? JSON.parse(data?.email_notification_array)
      : defaultArray;

    // Ensure all required notification types exist in the array
    const requiredTypes = [
      { noti_type: 'email', type: undefined },
      { noti_type: 'sms', type: undefined },
      { noti_type: 'email', type: 'receive', source: 'in-app' },
      { noti_type: 'sms', type: 'receive', source: 'in-app' },
      { noti_type: 'email', type: 'receive', source: 'gradmap' },
      { noti_type: 'sms', type: 'receive', source: 'gradmap' },
    ];

    // Add missing notification types with default values
    requiredTypes.forEach(({ noti_type, type, source }) => {
      const exists = emailArray.some((item: any) =>
        item.noti_type === noti_type &&
        (type ? item.type === type : !item.type) &&
        (source ? item.source === source : !item.source)
      );
      if (!exists) {
        emailArray.push({
          noti_type,
          is_enabled: false,
          ...(type && { type }),
          ...(source && { source }),
        });
      }
    });

    const updatedArray = emailArray.map((item: any) => {
      if (
        item.noti_type === userType &&
        (notificationType ? item.type === notificationType : !item.type) &&
        (source ? item.source === source : !item.source)
      ) {
        return { ...item, is_enabled: isEnabled };
      }
      return item;
    });

    const dataUpdate = {
      ...data,
      email_notification_array: JSON.stringify(updatedArray),
      email: personalStore?.email,
      user_id: userId,
    };

    notificationServices.updateNotification(dataUpdate).then((res: any) => {
      if (res) {
        toast.success('Update notification status successfully');
        getData();
        toast.dismiss(toastId);
      }
    });
  };

  return !loading ? (
    <div>
      <div>
        {/* <div className="tab-panel2-content">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center">
                <div
                  className="text-primary p-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center"
                  style={{ width: '35px', height: '35px', marginRight: '8px' }}
                >
                  <BellOutlinedIcon className="text-primray-light" width={'18px'} height={'18px'} />
                </div>
                <div className="text-primary fs-4 fw-bold">Send Notifications</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <Row className="mt-4">
          <Col xs={12} className="mb-4">
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-0">
                <TableContainer component={'div'}>
                  <Table sx={{ minWidth: 650 }} aria-label="send notifications table">
                    <TableHead>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{ backgroundColor: '#FCFBFC' }}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="text-field-mid fs-16px pl-30px"
                        >
                          Email Notifications
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            checked={getEmailNotificationStatus('email')}
                            onChange={(_: any, checked: boolean) =>
                              updateEmailNotificationStatus('email', checked)
                            }
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#FCFBFC' }}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="text-field-mid fs-16px pl-30px"
                        >
                          SMS Notifications
                        </TableCell>

                        <TableCell align="center">
                          <Checkbox
                            checked={getEmailNotificationStatus('sms')}
                            onChange={(_: any, checked: boolean) =>
                              updateEmailNotificationStatus('sms', checked)
                            }
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}

        {/* <div className="tab-panel2-content mt-4"> */}
        <Row className="">
          <Col xs={12} className="mt-2">
            <div className="bg-white p-2">
              <div className="d-flex align-items-center">
                <div
                  className="text-primary p-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center"
                  style={{ width: '35px', height: '35px', marginRight: '10px' }}
                >
                  <BellOutlinedIcon className="text-primray-light" width={'18px'} height={'18px'} />
                </div>
                <div>
                  <div className="text-primary fs-4 fw-bold mb-1">SMS Notifications</div>
                  <div className="text-field-light">
                    Manage what you want to be notified about through SMS messages.
                  </div>
                </div>
              </div>

              <div
                className="mt-4 pt-3 pb-2"
                style={{
                  borderTop: '1px solid #e5e7eb',
                  borderBottom: '1px solid #e5e7eb',
                }}
              >
                <div className="fw-semibold text-field-mid">Notification Type</div>
              </div>

              <div className="mt-4">
                {[
                  {
                    key: 'gradmap',
                    title: 'GradMap Updates SMS Notifications',
                    desc:
                      'I agree to receive SMS update messages from GradMap to the phone number provided in my profile above. Message frequency may vary, data rates may apply, reply STOP or uncheck the box to opt out.',
                    source: 'gradmap',
                  },
                  {
                    key: 'in-app',
                    title: 'GradMap In-App Messaging SMS Notifications',
                    desc:
                      'I agree to receive SMS conversation messages (with other users) from GradMap to the phone number provided in my profile above. Message frequency may vary, data rates may apply, reply STOP or uncheck the box to opt out.',
                    source: 'in-app',
                  },
                ].map((item, idx) => (
                  <div
                    key={item.key}
                    className="d-flex align-items-start"
                    style={{
                      padding: '18px 4px',
                      borderBottom: idx === 0 ? '1px solid #eee' : 'none',
                    }}
                  >
                    <div style={{ flex: 1, paddingRight: '12px', textAlign: 'left' }}>
                      <div className="fw-semibold text-field-mid d-flex align-items-center mb-2">
                        <SmartphoneOutlinedIcon fontSize="small" className="me-2 text-field-mid" />
                        {item.title}
                      </div>
                      <div className="text-field-light" style={{ lineHeight: 1.6 }}>
                        {item.desc}
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        textAlign: 'right',
                      }}
                    >
                      <Checkbox
                        checked={getEmailNotificationStatus('sms', 'receive', item.source)}
                        onChange={(_: any, checked: boolean) =>
                          updateEmailNotificationStatus('sms', checked, 'receive', item.source)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* Student Notifications Section */}
          {/* <Col xs={12}>
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-success text-white">
              <div className="d-flex align-items-center">
                <SmartPhoneOutlinedIcon className="me-2" />
                <h5 className="mb-0">Student Notifications</h5>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <TableContainer component={'div'}>
                <Table sx={{ minWidth: 650 }} aria-label="student notifications table">
                  <TableHead>
                    <TableRow className="bg-light">
                      <TableCell className="fw-bold">Notification Type</TableCell>
                      <TableCell align="center" className="fs-16px fw-bold">
                        <SmartPhoneOutlinedIcon
                          fontSize="small"
                          className="text-field-light mr-4px"
                        />
                        Phone
                      </TableCell>
                      <TableCell align="center" className="fs-16px fw-bold">
                        <EmailOutlinedIcon fontSize="small" className="text-field-light mr-4px" />
                        Email
                      </TableCell>
                      <TableCell align="center" className="fs-16px fw-bold">
                        <BellOutlinedIcon
                          fontSize="small"
                          className="text-field-light mr-4px"
                        />
                        In-App
                      </TableCell>
                      <TableCell align="center" className="fs-16px fw-bold">
                        <BellOutlinedIcon
                          fontSize="small"
                          className="text-field-light mr-4px"
                        />
                        Push
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow sx={{ backgroundColor: '#FCFBFC' }}>
                      <TableCell
                        component="th"
                        scope="row"
                        className="text-field-mid fs-16px pl-30px"
                      >
                        Application Status
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getApplicationStatus(0)}
                          onChange={(_: any, checked: boolean) => updateApplicationStatus(0, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getApplicationStatus(1)}
                          onChange={(_: any, checked: boolean) => updateApplicationStatus(1, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getApplicationStatus(2)}
                          onChange={(_: any, checked: boolean) => updateApplicationStatus(2, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getApplicationStatus(3)}
                          onChange={(_: any, checked: boolean) => updateApplicationStatus(3, checked)}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        component="th"
                        scope="row"
                        className="text-field-mid fs-16px pl-30px"
                      >
                        News & Updates
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getNewsStatus(0)}
                          onChange={(_, checked) => updateNewsStatus(0, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getNewsStatus(1)}
                          onChange={(_, checked) => updateNewsStatus(1, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getNewsStatus(2)}
                          onChange={(_, checked) => updateNewsStatus(2, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getNewsStatus(3)}
                          onChange={(_, checked) => updateNewsStatus(3, checked)}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#FCFBFC' }}>
                      <TableCell
                        component="th"
                        scope="row"
                        className="text-field-mid fs-16px pl-30px"
                      >
                        Special Dates
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getSpecialDatesStatus(0)}
                          onChange={(_, checked) => updateSpecialDatesStatus(0, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getSpecialDatesStatus(1)}
                          onChange={(_, checked) => updateSpecialDatesStatus(1, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getSpecialDatesStatus(2)}
                          onChange={(_, checked) => updateSpecialDatesStatus(2, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getSpecialDatesStatus(3)}
                          onChange={(_, checked) => updateSpecialDatesStatus(3, checked)}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        component="th"
                        scope="row"
                        className="text-field-mid fs-16px pl-30px"
                      >
                        College Updates
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getCollegeUpdatesStatus(0)}
                          onChange={(_, checked) => updateCollegeUpdatesStatus(0, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getCollegeUpdatesStatus(1)}
                          onChange={(_, checked) => updateCollegeUpdatesStatus(1, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getCollegeUpdatesStatus(2)}
                          onChange={(_, checked) => updateCollegeUpdatesStatus(2, checked)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={getCollegeUpdatesStatus(3)}
                          onChange={(_, checked) => updateCollegeUpdatesStatus(3, checked)}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card.Body>
          </Card>
        </Col> */}
        </Row>

        <style scoped>{`
        th, td {
          border: none !important;
        }
        .card-header {
          border-bottom: 1px solid rgba(0,0,0,.125);
        }
      `}</style>
      </div>
    </div>
  ) : (
    <div className="tab-wrap-panel">
      <div className="tab-panel2">
        <div className="tab-panel2-content">
          <Row className="m-0 p-0">
            <Col md={12} className="text-center">
              <h3>Loading...</h3>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SettingsNotification;
